import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import classNames from 'classnames';

import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import CircularProgress from '@material-ui/core/CircularProgress';

import { connect } from 'react-redux';

import PlayIcon from '@material-ui/icons/PlayArrow';

import Link from '../../../components/Link';
import s from './GoToNextSection.scss';
import messages from '../lessonDetailsMessages';

@withStyles(s)
@withWidth()
@injectIntl
@connect(state => ({
  auth: state.auth,
  lesson: state.lessonDetails.lesson,
  course: state.courseDetails.course,
}))
export default class GoToNextSection extends React.Component {
  static propTypes = {
    nextItem: PropTypes.shape({
      item: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    course: PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      type: PropTypes.string,
    }).isRequired,
    nextUrl: PropTypes.string,
    intl: intlShape.isRequired,
    goToNextSectionItemProgress: PropTypes.number.isRequired,
    cancelGoToNextSectionItem: PropTypes.func.isRequired,
    width: PropTypes.string.isRequired,
    nextPodcastItemClickHandler: PropTypes.func,
  };

  static defaultProps = {
    nextPodcastItemClickHandler: _.noop,
    nextUrl: '',
  };

  render() {
    const {
      goToNextSectionItemProgress,
      nextItem,
      nextUrl,
      course,
      cancelGoToNextSectionItem,
      width,
      nextPodcastItemClickHandler,
    } = this.props;

    const isPodcast = course.type === 'podcast';

    let size = 140;

    if (width === 'xs') {
      size = 64;
    } else if (width === 'sm') {
      size = 96;
    }

    if (isPodcast) {
      size = 64;
    }
    return (
      <div
        className={classNames(s.nextSectionItemView, {
          [s.podcast]: isPodcast,
        })}
      >
        <div
          className={classNames(s.upNext, {
            [s.podcast]: isPodcast,
          })}
        >
          <FormattedMessage {...messages.upNextText} />
        </div>
        <Typography
          variant="h1"
          className={classNames(s.nextSectionItemTitle, {
            [s.podcast]: isPodcast,
          })}
        >
          {_.get(nextItem, 'item.name', '')}
        </Typography>
        <IconButton
          data-test-id="YYUtANAYCuBVTibNusY8F"
          className={classNames(s.timeOutProgressWrapper, {
            [s.podcast]: isPodcast,
          })}
          component={isPodcast ? 'button' : Link}
          to={`/courses/${course.slug}/${nextUrl}`}
          onClick={nextPodcastItemClickHandler}
        >
          <CircularProgress
            className={s.timeOutProgress}
            variant="determinate"
            size={size}
            thickness={3}
            value={goToNextSectionItemProgress}
          />
          <PlayIcon
            className={classNames(s.playNextSectionItemIcon, {
              [s.podcast]: isPodcast,
            })}
          />
        </IconButton>
        <Button
          data-test-id="gpZlICL0Dv1LA7HingtaA"
          onClick={cancelGoToNextSectionItem}
          className={classNames(s.cancelNextSectionItemBtn, {
            [s.podcast]: isPodcast,
          })}
          fullWidth
        >
          <FormattedMessage {...messages.cancel} />
        </Button>
      </div>
    );
  }
}
